// Réveil anticipé de l'API (APR-20261011-02). Cloud Run descend à 0 instance au repos : la
// première requête attendait ~22 s le démarrage (mesuré : connexion du 2026-10-11, callback
// lui-même en 0,16 s). Un GET /api/health au chargement de l'app fait démarrer l'API pendant que
// l'utilisateur est chez le fournisseur d'identité. Requête simple (sans en-tête, no-cors : pas
// de preflight), jamais attendue, jamais bloquante.
export function wakeApi(backendUrl = process.env.REACT_APP_BACKEND_URL || "", fetchImpl = globalThis.fetch) {
  if (typeof fetchImpl !== "function") return;
  try {
    const pending = fetchImpl(`${backendUrl}/api/health`, { mode: "no-cors", cache: "no-store" });
    if (pending && typeof pending.catch === "function") pending.catch(() => {});
  } catch {
    // réseau indisponible : l'app démarre quand même
  }
}
